<div class="confirm-dialog">

  <div class="dialog-icon">
    <mat-icon>check</mat-icon>
  </div>

  <div
    mat-dialog-content
    class="dialog-message"
  >
    {{ data.message |translate }}
  </div>

  <div
    mat-dialog-actions
    class="dialog-actions"
  >

    <button
      mat-button
      type="button"
      class="cancel-btn"
      (click)="onCancel()"
    >
      {{'COMMON.CLOSE' | translate}}
    </button>

   

  </div>

</div>